import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { liveSales } from '../data/products';
const VISIBLE_MS = 7000;
const HIDDEN_MS = 5000;
export function LiveSaleToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const firstDelay = window.setTimeout(() => setVisible(true), 3500);
    return () => window.clearTimeout(firstDelay);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    const hide = window.setTimeout(() => setVisible(false), VISIBLE_MS);
    return () => window.clearTimeout(hide);
  }, [visible, dismissed, index]);
  useEffect(() => {
    if (dismissed || visible) return;
    const next = window.setTimeout(() => {
      setIndex(current => (current + 1) % liveSales.length);
      setVisible(true);
    }, HIDDEN_MS);
    return () => window.clearTimeout(next);
  }, [visible, dismissed]);
  const sale = liveSales[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-6 left-4 z-40 sm:left-6" data-id="element-146" data-mp="3rc64b2wjjktz">
      <AnimatePresence data-id="element-147" data-mp="3dj6ot0wrdqmf">
        {visible && !dismissed && <motion.div key={sale.id} initial={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[19rem] items-center gap-3 border border-line bg-white p-3 shadow-[0_8px_30px_rgba(115,63,45,0.10)] sm:w-[21rem]" data-id="element-148" data-mp="3hltfuzllv7ik">
            <img src={sale.image} alt={sale.product} className="h-12 w-12 shrink-0 object-cover" data-id="element-149" data-mp="2ynh5jaiyjrle" />
            <div className="min-w-0 flex-1" data-id="element-150" data-mp="ww4630zrebwq">
              <p className="flex items-center gap-1.5 font-sans text-[9px] uppercase tracking-luxe text-gold-deep" data-id="element-151" data-mp="wut2b16bd45m">
                <span className="relative flex h-1.5 w-1.5" aria-hidden="true" data-id="element-152" data-mp="25qg7btnenns1">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-500 opacity-70" data-id="element-153" data-mp="20s4uda1tcx5l" />
                  <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-emerald-600" data-id="element-154" data-mp="1wtp9pct7g0vc" />
                </span>
                Just purchased
              </p>
              <p className="mt-1.5 font-sans text-[12px] font-light leading-snug text-maroon-soft" data-id="element-155" data-mp="2oiirhez99m71">
                Someone in <span className="text-maroon" data-id="element-156" data-mp="2ki8gtp0iq7lu">{sale.city}</span> just
                purchased a <span className="text-maroon" data-id="element-157" data-mp="2fp5nnhznl066">{sale.product}</span>{' '}
                <span className="text-maroon-mute" data-id="element-158" data-mp="2asf7kunum4kr">({sale.minutesAgo} mins ago)</span>
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss purchase notification" className="self-start text-maroon-mute transition-colors duration-150 ease-luxe hover:text-maroon" data-id="element-159" data-mp="387t3ahvvrmzv">
              <XIcon className="h-3.5 w-3.5" strokeWidth={1.5} data-id="element-160" data-mp="3fpr1hq8m3bns" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}